import type { SuperAdminReadyForReviewRequest } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../types/tables";

import { inlineAssigneeCell } from "../../helpers/cellRenderers";
import {
  accountCellWithSlotTooltip,
  createdByCell,
  dateCell,
  nameCell,
  requestDesignTypeCell,
} from "../../helpers/commonCells";

// Ready for Review Tab Configuration for SuperAdmin
// Columns: Name, Account, Assignee, Created by, Created date, Request/Design type
export const readyForReviewTableConfig: TableConfig<SuperAdminReadyForReviewRequest> =
  {
    columns: [
      {
        accessor: "name",
        cellRenderer: nameCell,
        header: "Name",
        key: "name",
        sortable: true,
        width: 220,
      },
      {
        accessor: "account",
        cellRenderer: accountCellWithSlotTooltip,
        header: "Account",
        key: "account",
        sortable: true,
        width: 180,
      },
      {
        accessor: "assignee",
        cellRenderer: inlineAssigneeCell, // Inline editable
        header: "Assignee",
        key: "assignee",
        sortable: true,
        width: 160,
      },
      {
        accessor: "createdBy",
        cellRenderer: createdByCell,
        header: "Created by",
        key: "createdBy",
        sortable: true,
        width: 140,
      },
      {
        accessor: "createdAt",
        cellRenderer: dateCell,
        header: "Created date",
        key: "createdAt",
        sortable: true,
        width: 130,
      },
      {
        accessor: "designType",
        cellRenderer: requestDesignTypeCell,
        header: "Request/Design type",
        key: "designType",
        sortable: true,
        width: 180,
      },
    ],
    defaultSort: {
      column: "createdAt",
      direction: "desc",
    },
    enableSorting: true,
    getRowClassName: whitelabelRowClassName,
    id: "superadmin-ready-for-review-requests",
    title: "Ready for Review",
  };
